export default function ShadowPricetagDefs({id = "shadow_pricetag"}) {
    return (
        <filter
            id={id}
            x="-2%"
            y="-2%"
            width="104%"
            height="104%"
        >
            <feDropShadow
                dx="0.2"
                dy="0.6"
                stdDeviation="0.25"
                floodColor="#000"
                floodOpacity="0.55"
            />
        </filter>
    );
}
